/**
 * Triggers the Google Tag event
 * Example usage:
 * This event is used (for now) in Google Tag to trigger a Google Optimize Event
 * Google Optimize will cause the CTA Button to rotate different button labels.
 *
 * @param {String} event
 * @returns {null}
 */
export default function triggerEvent(eventName) {
  if (window && window.dataLayer) {
    return window.dataLayer.push({ event: eventName });
  }

  return undefined;
}
